import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './PostsList.scss'

import { List } from './'
import { PostCard } from '../PostCard'

const PostsList = ({ header, info, footer, posts }) =>
	<List
		header={header}
		info={info}
		body={
			<div className={styles.list}>
				{posts.map((post, i) => {
					const {
						shell,
						url,
						category,
						title,
						excerpt,
						author,
						image
					} = post
					return (
						<PostCard
							shell={shell}
							key={i}
							category={category || 'Productivity'}
							title={title}
							excerpt={excerpt}
							url={url}
							author={author}
							image={image}
						/>
					)
				})}
			</div>
		}
		footer={footer}
	/>

PostsList.propTypes = {
	apps: React.PropTypes.array
}

export default CSSModules(PostsList, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/PostsList.js